import React, { useState } from 'react';
import Button from 'Components/Button';
import Overlay from 'Components/Overlay';
import DetailedLog from 'Components/DetailedLog';
import Share from 'Components/TripTrackingSideBar/Share';
import { ReactComponent as ShareIcon } from 'Components/TripTrackingSideBar/icons/share.svg';
import { useDetailedLog } from '../hooks/useDetailedLog';
import { useShareDetails } from '../hooks/useShareDetails';
import { downloadFastTagLogs } from '../utils/downloadFastTagLogs';
import styles from '../TripTrackingV2.module.scss';

// Ported from the old tracking sidebar's action row (View detailed log /
// Share / Download FastTag Logs), reusing the same DetailedLog/Share/Overlay
// components - only the data-fetching underneath is new (plain hooks
// instead of redux, matching the rest of this screen).
const TripActions = ({ trip }) => {
  const [showDetailedLog, setShowDetailedLog] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const { locations, isLoaded, search } = useDetailedLog(trip.tripId);
  const { shareDetails, fetchShareDetails, saveShareDetails } = useShareDetails(trip.tripId);

  const openShare = () => {
    setShowShare(true);
    fetchShareDetails();
  };

  return (
    <section className={styles.actionsRow}>
      <Button className="button-outlined" value="View detailed log" onClick={() => setShowDetailedLog(true)} />
      <Button className="button-outlined" value="Download FastTag Logs" onClick={() => downloadFastTagLogs(trip.tripId)} />
      <div className={styles.shareButton} onClick={openShare}>
        <ShareIcon width="16px" height="16px" />
        <span>Share</span>
      </div>

      {showDetailedLog && (
        <Overlay show={showDetailedLog} hideOverlay={() => setShowDetailedLog(false)}>
          <DetailedLog
            isDetailedLogLoaded={isLoaded}
            search={search}
            locations={locations}
            trackingType={trip.trackingType}
            tripId={trip.tripId}
          />
        </Overlay>
      )}

      {showShare && (
        <Overlay show={showShare} hideOverlay={() => setShowShare(false)} containerClass="share-details">
          <Share hideOverlay={() => setShowShare(false)} shareDetails={shareDetails} onSaveSharedDetails={saveShareDetails} />
        </Overlay>
      )}
    </section>
  );
};

export default TripActions;
